// extracted by mini-css-extract-plugin
export default {"body":"results_body__yLPS9"};